import { axiosWdw, domainEndpoint } from '@/api/axios';
import { ICategory } from '@/models/category.model';

const endpoint = '/category';

export default {
  getCategoriesByQueryParams(params?: unknown): Promise<ICategory[]> {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint,
        params: params,
      })
        .then(response => {
          resolve(response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getCategoryById(categoryid: number): Promise<ICategory> {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + `/${categoryid}`,
      })
        .then(response => {
          resolve(response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
